<template>
  <div class="AboutUs">
    <au_header></au_header>
    <au_info></au_info>
    <!-- <p_table></p_table> -->
    <co_org></co_org>
  </div>
</template>

<script>
// @ is an alias to /src
import AUHeader from '@/components/aboutus/Header.vue';
 import AUInfo from '@/components/aboutus/Info.vue';
 import PTable from '@/components/aboutus/ProvinceTable.vue'
 import CoOrganiser from '@/components/aboutus/CoOrganiser.vue'

export default {
  name: 'AboutUs',
   components: {
     au_header: AUHeader,
     au_info: AUInfo,
     p_table: PTable,
     co_org: CoOrganiser
   },
}
</script>
